import { authAxios as axios } from "api-generate-types/src/axios";
import config from "config/global";

export default async function getMySuggestionsCount() {
  const response = await axios(
    `${config.suggestionsApiUrl}/suggestions/count`,
    {}
  );

  return response.data;
}
